module.exports = __webpack_public_path__ + "static/media/auto-geni-logo-light.0de3b54d.svg";